module.exports = __webpack_public_path__ + "img/16.57856aa.jpg";